import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
    /** 当前条件命中的真实总数，不受深翻页截断影响 */
    total: number;
    /** 深翻页截断后可查看的条数；未被截断时传 null */
    viewableCap: number | null;
};

/**
 * 订单列表的合计文案：「共 N 条」，被深翻页保护截断时追加「（仅可查看前 M 条）」。
 *
 * <p>抽成组件是因为有两个渲染位置（导出工具条 / 分页器 showTotal），共用一份截断分支。
 */
const OrderTotalLabel: React.FC<Props> = ({ total, viewableCap }) => {
    const { t } = useTranslation();

    return (
        <span className="text-sm text-gray-500">
            {viewableCap === null
                ? t('orderQuery.pagination.total', { total })
                : t('orderQuery.pagination.totalCapped', { total, cap: viewableCap })}
        </span>
    );
};

export default OrderTotalLabel;
